export default __webpack_public_path__ + "static/Perroquet-site-web-membre-cite-entrepreneurs-euromediterranee-498a4730b17b6770a7cb0993f2d02db2.jpg";